<template>
  <div class="text-[15px] font-normal text-gray-600">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ProductDetailDescriptionText',
}
</script>
